var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.title,
        width: "600px",
        footer: null,
        destroyOnClose: ""
      },
      on: { cancel: _vm.close },
      model: {
        value: _vm.modalShow,
        callback: function($$v) {
          _vm.modalShow = $$v
        },
        expression: "modalShow"
      }
    },
    [
      _vm.dialogType != "detail"
        ? _c(
            "a-form-model",
            {
              ref: "ruleForm",
              staticClass: "common-form-inline",
              attrs: {
                rules: _vm.ruleForm,
                model: _vm.pageData,
                "label-col": { span: 4 },
                "wrapper-col": { span: 13 }
              }
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "凭证类型", prop: "documentType" } },
                        [
                          _c(
                            "a-radio-group",
                            {
                              model: {
                                value: _vm.pageData.documentType,
                                callback: function($$v) {
                                  _vm.$set(_vm.pageData, "documentType", $$v)
                                },
                                expression: "pageData.documentType"
                              }
                            },
                            _vm._l(_vm.VoucherDocumentTypeList, function(item) {
                              return _c(
                                "a-radio",
                                {
                                  key: item.dctVal,
                                  attrs: { value: item.dctVal }
                                },
                                [_vm._v(_vm._s(item.dctValNm))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "凭证编号", prop: "voucherCode" } },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入" },
                            on: { blur: _vm.getTableList },
                            model: {
                              value: _vm.pageData.voucherCode,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "voucherCode", $$v)
                              },
                              expression: "pageData.voucherCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "附件上传", prop: "fileId" } },
                        [
                          _c(
                            "div",
                            { staticStyle: { position: "relative" } },
                            [
                              _c("fileUpload", {
                                ref: "fileUpload",
                                attrs: {
                                  accept:
                                    ".png,.PNG,.jpg,.JPG,.jpeg,.JPEG,.bmp,.pdf,.PDF",
                                  paramObj: _vm.uploadParam,
                                  removeaction: true,
                                  name: "file"
                                },
                                on: {
                                  uploadOk: _vm.uploadOk,
                                  handleFileRemove: _vm.removeOk
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "text-color-orange img-tip" },
                                [
                                  _vm._v(
                                    "注：附件支持图片及pdf格式，且大小不可超过30M"
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dialogType != "detail"
        ? _c(
            "div",
            {
              staticClass: "spaceCenter",
              staticStyle: { "margin-bottom": "16px" }
            },
            [
              _c("button-load", {
                attrs: { type: "primary", lable: "导入列表" },
                on: { clickHandle: _vm.save }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-common common" },
        [
          _c("a-table", {
            attrs: {
              loading: _vm.tableLoading,
              size: "middle",
              columns: _vm.columns,
              "row-key": function(record) {
                return record.id
              },
              "data-source": _vm.tableData,
              pagination: false,
              bordered: "",
              locale: { emptyText: "暂无数据" }
            },
            scopedSlots: _vm._u([
              {
                key: "documentType",
                fn: function(text) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm._f("dictFilter")(text, _vm.VoucherDocumentTypeList)
                      )
                    )
                  ]
                }
              },
              {
                key: "createTime",
                fn: function(text) {
                  return [
                    _vm._v(_vm._s(_vm._f("dateFormat")(text, "YYYY-mm-dd")))
                  ]
                }
              },
              {
                key: "oper",
                fn: function(text, record, index) {
                  return [
                    _vm.dialogType != "detail"
                      ? _c(
                          "span",
                          {
                            staticClass: "text-color-red pointer",
                            on: {
                              click: function($event) {
                                return _vm.delFun(record, index)
                              }
                            }
                          },
                          [_vm._v("撤销")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            return _vm.downloadFile(record.file)
                          }
                        }
                      },
                      [_vm._v("下载附件")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f633de8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f633de8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bill-manage/payable/delivery-voucher-dialog.vue
// module id = 5jhf
// module chunks = 1